import { NavLink } from "react-router-dom";
import "../styles/NavBar.css";

export default function NavBar() {
  return (
    <nav
      className="navBar"
      aria-label="FourH navigation"
    >
      <NavLink
        to="/fourh"
        end
        className={({ isActive }) =>
          `fourHNavButton ${
            isActive ? "selected" : "unselected"
          }`
        }
      >
        Home
      </NavLink>
    </nav>
  );
}